module.exports = __webpack_public_path__ + "img/staff.09ec1119.png";